import $ from 'jquery';
import _get from 'lodash/get';
import {
	transformClientFormatToServer
} from '../lib/buttonModel';
import { destroy } from 'redux-form';
import { BTN_FACTORY_FORM } from '../clientConstants';

export const BUTTON_FACTORY_BUSY = 'BUTTON_FACTORY_BUSY';
export const INITIALIZE_WIZARD = 'INITIALIZE_WIZARD';
export const WIZARD_CONTINUE = 'WIZARD_CONTINUE';
export const WIZARD_BACK = 'WIZARD_BACK';
export const WIZARD_SET_CURRENT_PAGE = 'WIZARD_SET_CURRENT_PAGE';
export const GET_BUTTON_DATA_SUCCESS = 'GET_BUTTON_DATA_SUCCESS';
export const GET_BUTTON_DATA_ERROR = 'GET_BUTTON_DATA_ERROR';
export const CREATE_BUTTON_SUCCESS = 'CREATE_BUTTON_SUCCESS';
export const CREATE_BUTTON_ERROR = 'CREATE_BUTTON_ERROR';
export const EDIT_BUTTON_SUCCESS = 'EDIT_BUTTON_SUCCESS';
export const EDIT_BUTTON_ERROR = 'EDIT_BUTTON_ERROR';
export const UPDATE_CODE_SNIPPET = 'UPDATE_CODE_SNIPPET';
export const SHOW_LOGIN_MODAL = 'SHOW_LOGIN_MODAL';
export const HIDE_LOGIN_MODAL = 'HIDE_LOGIN_MODAL';
export const SHOW_ACTIONABLE_ERROR_MODAL = 'SHOW_ACTIONABLE_ERROR_MODAL';
export const HIDE_ACTIONABLE_ERROR_MODAL = 'HIDE_ACTIONABLE_ERROR_MODAL';
export const SHOW_UNACTIONABLE_ERROR_MODAL = 'SHOW_UNACTIONABLE_ERROR_MODAL';
export const HIDE_UNACTIONABLE_ERROR_MODAL = 'HIDE_UNACTIONABLE_ERROR_MODAL';

export function goToNextStep() {
	return {
		type: WIZARD_CONTINUE
	}
}

export function goToPreviousStep() {
	return {
		type: WIZARD_BACK
	}
}

export function setCurrentStep(stepNumber) {
	return {
		type: WIZARD_SET_CURRENT_PAGE,
		payload: stepNumber
	}
}

export function initializeWizard(button) {
	return {
		type: INITIALIZE_WIZARD,
		payload: button
	}
}

export function busy() {
	return {
		type: BUTTON_FACTORY_BUSY
	};
}

export function getButton(buttonId) {
	return (dispatch, getState) => {
		dispatch(busy());

		return $.get(`/donate/api/buttons/${buttonId}`)
			.done((response) => {
				const button = _get(response, 'button');

				dispatch({
					type: GET_BUTTON_DATA_SUCCESS,
					payload: button
				});

				return button;
			})
			.fail((err) => {
				const error = _get(err, 'responseJSON.button');
				dispatch({
					type: GET_BUTTON_DATA_ERROR,
					payload: { error }
				});
				return err;
			})
	};
}

export function saveButton(buttonData) {
	return (dispatch) => {
		if (buttonData.id) {
			return dispatch(updateButton(buttonData));
		}

		return dispatch(createButton(buttonData));
	}
}

export function createButton(buttonData) {
	const buttonDataServerFormat = transformClientFormatToServer(buttonData);

	return (dispatch, getState) => {
		dispatch(busy());

		const urlParams = {
			url: '/donate/api/buttons',
			method: 'POST',
			data: {
				button: buttonDataServerFormat
			}
		}

		return $.ajax(urlParams)
			.done((response) => {
				const button = _get(response, 'button');

				dispatch({
					type: CREATE_BUTTON_SUCCESS,
					payload: button
				});
				return button;
			})
			.fail((error) => {
				dispatch({
					type: CREATE_BUTTON_ERROR,
					payload: {
						error
					}
				});
				return error;
			})
	}
}

export function updateButton(buttonData) {
	const buttonDataServerFormat = transformClientFormatToServer(buttonData);

	return (dispatch, getState) => {
		dispatch(busy());

		const urlParams = {
			url: `/donate/api/buttons/${buttonData.id}`,
			method: 'PUT',
			data: {
				button: buttonDataServerFormat
			}
		}
		return $.ajax(urlParams)
			.done((response) => {
				const button = _get(response, 'button');

				dispatch({
					type: EDIT_BUTTON_SUCCESS,
					payload: button
				});
				return button;
			})
			.fail((error) => {
				dispatch({
					type: EDIT_BUTTON_ERROR,
					payload: {
						error
					}
				});
				return error;
			})
	}
}

export function updateCodeSnippet(code) {
	return {
		type: UPDATE_CODE_SNIPPET,
		payload: code
	}
}

export function showLoginModal() {
	return {
		type: SHOW_LOGIN_MODAL
	}
}

export function hideLoginModal() {
	return {
		type: HIDE_LOGIN_MODAL
	}
}

export function showActionableErrorModal() {
	return {
		type: SHOW_ACTIONABLE_ERROR_MODAL
	}
}

export function hideActionableErroModal() {
	return {
		type: HIDE_ACTIONABLE_ERROR_MODAL
	}
}

export function showUnactionableErrorModal() {
	return {
		type: SHOW_UNACTIONABLE_ERROR_MODAL
	}
}

export function hideUnactionableErrorModal() {
	return {
		type: HIDE_UNACTIONABLE_ERROR_MODAL
	}
}

export function destroyForm() {
	return (dispatch) => {
		dispatch(destroy(BTN_FACTORY_FORM))
	}
}



// WEBPACK FOOTER //
// ./buttons/actions/actionsButtonFactory.js